module.exports = __webpack_public_path__ + "static/media/feishu1-0001.2444280f.png";